// extracted by mini-css-extract-plugin
export default {"whatsappBtn":"Whatsapbut_whatsappBtn__11Krq"};